export default "__VITE_ASSET__BcTGqAAu__"